// src/utils/validation.ts

export function validatePhone(number: string): boolean {
  const trimmed = number.trim();
  // Дозволяємо + на початку, потім від 7 до 15 цифр
  return /^(\+)?[0-9]{7,15}$/.test(trimmed);
}

export function containsInvalidChar(number: string): boolean {
  // Дозволяємо тільки цифри та символ +
  return /[^0-9+]/.test(number);
}

export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
